import { SearchInput, SearchProps } from '@/components/basic';
import { cn } from '@/lib/utils';
import { ScrollArea } from '@mantine/core';
import React from 'react';

export interface SearchableListProps
  extends React.PropsWithChildren<Record<never, never>> {
  title?: string;
  teamSearchQuery: string;
  setSearchQuery: SearchProps['setQuery'];
  actionElement: JSX.Element;
  scrollAreaClassName?: string;
  offsetScrollbars?: boolean;
  className?: string;
}
export const SearchableList = ({
  title,
  teamSearchQuery,
  setSearchQuery,
  actionElement,
  children,
  scrollAreaClassName,
  offsetScrollbars,
  className
}: SearchableListProps) => (
  <div className={cn("pt-6 flex flex-1 flex-col flex-nowrap items-stretch gap-3 overflow-hidden px-1", className)}>
    {title ? (
      <h3 className="py-1 text-lg font-bold text-secondary [.tactic-v2_&]:text-secondary-foreground">
        {title}
      </h3>
    ) : null}
    <div className="flex items-center justify-between gap-4 sm:gap-16">
      <SearchInput query={teamSearchQuery} setQuery={setSearchQuery} />
      {actionElement}
    </div>
    <ScrollArea
      type="auto"
      offsetScrollbars={offsetScrollbars !== false}
      className={cn('h-full', scrollAreaClassName)}
      classNames={{
        root: 'rounded-lg border border border-gray-300'
      }}
    >
      <ul className="divide-y divide-gray-200">{children}</ul>
    </ScrollArea>
  </div>
);
